import { Card } from '@mui/material'
import clsx from 'clsx'
import React from 'react'

import { UCardProps } from './type'

export const UCard = ({
  className,
  children,
  padding = 3,
  radius = 8,
  elevation = 0,
}: UCardProps) => {
  return (
    <Card
      className={clsx('p-' + padding, 'radius-' + radius, className)}
      elevation={elevation}
    >
      {children}
    </Card>
  )
}
